import fetchWithTimeout from "../../utils/fetchWithTimeout";
import PubSub from "../../utils/PubSub";

export default async function updateCartQuantity(key, quantity) {
  const context = "quantityUpdate";
  PubSub.publish(`cart:${context}:start`, { key, quantity });

  const response = await fetchWithTimeout(
    cartVars.ajaxUrl,
    {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        action: "update_cart_quantity",
        key,
        quantity,
        nonce: cartVars.nonce,
      }),
    },
    5000,
    context
  );

  if (response.success) {
    PubSub.publish(`cart:${context}:success`, {
      key,
      data: {
        ...response.data,
        key,
        quantity: parseInt(quantity, 10),
      },
    });
  } else {
    PubSub.publish(`cart:${context}:error`, { key, error: response.error });
  }
}
